import {Routes, RouterModule, Router} from "@angular/router";
import {Component, OnInit, ViewChild} from "@angular/core";
import {SearchValue} from "./searchvalue.service";

@Component({
  selector: 'app-root',
  template: `
        <header>
        
            <nav class="slide-left"  *ngIf="isMenuOn">
            <ul>
                <li class="c-menu__item"><a  [routerLink]="['/']">首頁</a></li>
                
                <li><a [routerLink]="['about']" routerLinkActive="active">關於波爾</a></li>
                
                <li class="c-menu__item"><a [routerLink]="['classroom']">蒞店花絮</a></li>
              
                <li class="c-menu__item"><a [routerLink]="['flow']">購物指南</a></li>
               
                 <li class="c-menu__item"><a [routerLink]="['member']">會員專區</a></li>
                 <li class="c-menu__item"><a [routerLink]="['notification']">匯款通知</a></li>
                
            </ul>
            </nav>
            <nav>
            <ul>  
                <li class="logo"><a [routerLink]="['/']"><img src="img/logo.png" height="65" ></a></li>

                <div class="sideMenu" (click)="sideMenuClick()"  #side><i class="fa fa-bars" aria-hidden="true"></i></div>
                
                <li><a [routerLink]="['about']" routerLinkActive="active">關於波爾</a></li>
                <li><a [routerLink]="['classroom']">蒞店花絮</a></li>
                <li><a [routerLink]="['flow']">購物指南</a></li> 
                 
                <li><a [routerLink]="['member']">會員專區</a></li>
                <li><a [routerLink]="['notification']">匯款通知</a></li> 
                
                <span class="navigation" >
                <li style="padding-left:5px;"><cart></cart></li>
                <li><a href="https://www.instagram.com/reel/DNX7kKmzUAg/?igsh=MTI2emN5eXdvM21tZw==" target="_blank"><img src="img/blog.png" height="32" width="32"></a></li>
                <li><a href="https://www.facebook.com/%E6%B3%A2%E7%88%BE%E6%A1%8C%E7%90%83%E7%94%A8%E5%93%81%E5%B0%88%E8%B3%A3%E5%BA%97-353230954792473/?fref=ts" target="_blank"><img src="img/fb.png" height="32" width="32"></a></li>
                </span>
            </ul>
            </nav>

        </header>

        <router-outlet></router-outlet>
        <footer>
            
			<div class="footer_top">
			    <div class="footer_new">北台灣桌球器材專賣店</div>
				<ul>
				  <li>電話：(02)3151-7171 | </li>
          <li>“假日”無提供網路購物客服, 網購請勿來電 | </li>
          <li>官網售價僅適用此平台下單商品 | </li>
          <li>星期一 門市店休, 平日 12:30 ~ 20:00, 假日 11:30 ~ 18:00 |</li>
					<li>新北市中和區自強路60號(秀山國小旁) |</li>
					<li>Mail：majestic168168@gmail.com |</li>
					<li>本店保留訂單成立與否之權利 |</li>
          <li>本店由 陳智全律師 擔任法律顧問 |</li>
				</ul>
			</div>
			<div class="footer_bottom">
					請指名BUTTERFLY蝴蝶牌直接供貨台灣經銷商
			</div>
		</footer>
    `,
  host: {
    '(window:click)': 'close($event)'
  }


})



export class AppComponent implements OnInit{
    isMenuOn: Boolean = false;
  @ViewChild('side') side: any;
  constructor(private router:Router,private searchvalue:SearchValue){

  }
  gotoResult(value,value2){
    this.searchvalue.add(value,value2);
    this.router.navigate(['SearchResult']);
  }
  ngOnInit(){

  }
  close(event){
    if (!this.side.nativeElement.contains(event.target)) {
      this.isMenuOn = false;
    }
  }

  sideMenuClick(){
      this.isMenuOn = !this.isMenuOn;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts